import { Link } from 'gatsby';
import React from 'react';
import SEO from '../components/seo';
import Img from 'gatsby-image';
import '../components/layout.css';
export default function LandingPage(props) {
  var name = props.data.site.siteMetadata.author;
  return /*#__PURE__*/React.createElement("div", {
    className: "font-sans bg-ocean-800 min-h-screen lg:h-screen lg:overflow-hidden flex flex-col"
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "Home",
    description: "The personal website and blog of Matthew Nelson, a literary scholar, teacher, and full-stack web developer",
    lang: "en-us"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-screen"
  }, /*#__PURE__*/React.createElement(Img, {
    fluid: props.data.shoreline.childImageSharp.fluid,
    alt: "An image of me on some rocks at the beach",
    style: {
      clipPath: 'ellipse(98% 58% at 48% 42%)',
      transform: 'scaleX(-1)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-6 flex-auto lg:flex lg:justify-around lg:px-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center self-center lg:mr-24"
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "Home"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "text-5xl text-ocean-100 mt-10 mb-10 lg:mt-0"
  }, "Hi, I\u2019m ", name), /*#__PURE__*/React.createElement("div", {
    className: "mx-auto mb-10 w-1/2 lg:h-full lg:w-full xl:w-4/5 lg:m-0 lg:mt-2"
  }, /*#__PURE__*/React.createElement(Img, {
    fluid: props.data.profile.childImageSharp.fluid,
    alt: "A photo of me",
    className: "rounded-full"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "self-center lg:pr-12"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-3xl text-cerise-500"
  }, "I\u2019m a ", /*#__PURE__*/React.createElement(Link, {
    to: "/teaching"
  }, "teacher"), ",", ' ', /*#__PURE__*/React.createElement(Link, {
    to: "/research"
  }, "scholar"), ", and", ' ', /*#__PURE__*/React.createElement(Link, {
    to: "/dev"
  }, "developer"), ".", ' '), /*#__PURE__*/React.createElement("p", {
    className: "text-ocean-100 mb-4 mt-6"
  }, "I\u2019m also an experienced editor and occasional translator."), /*#__PURE__*/React.createElement("p", {
    className: "text-ocean-100 my-4"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/contact",
    className: "text-cerise-400"
  }, "Get in touch"), ' ', "if you'd like to work with me, or if you have any questions or thoughts to share. I'd love to hear from you."), /*#__PURE__*/React.createElement("p", {
    className: "text-ocean-100 my-4"
  }, "While you\u2019re at it, be sure to check out my", ' ', /*#__PURE__*/React.createElement(Link, {
    to: "/blog",
    className: "text-cerise-400"
  }, "blog"), ' ', "too."))));
}
var pageQuery = "2583254655";